import {IRegionListRegion} from "../../../../search/actions/fetch_search_regions_action";
import {rankingYears} from "../../../constants/ranking";
import {IOfferRankingOptionValue} from "../../../types/IOfferRankingFormOptionValue";
import {IRankingCity} from "../../../types/IRankingCity";

interface IGetOfferRankingFormPeriodOptions {
    cities2023?: IRegionListRegion[];
    cities2022?: IRankingCity[];
    selectedCitySlug?: string;
}

export function getOfferRankingFormPeriodOptions(params: IGetOfferRankingFormPeriodOptions): IOfferRankingOptionValue[] {
    const {cities2023, cities2022, selectedCitySlug} = params;

    if (!cities2023 || !cities2022) {
        return [];
    }

    const cityIn2022 = selectedCitySlug ? Boolean(cities2022.find((city) => city.slug === selectedCitySlug)) : true;
    const cityIn2023 = selectedCitySlug ? Boolean(cities2023.find((city) => city.slug === selectedCitySlug)) : true;

    if (cityIn2022 && !cityIn2023) {
        const year2022 = rankingYears[1];

        return [
            {
                value: year2022.toString(),
                label: year2022.toString()
            }
        ];
    } else {
        return rankingYears.map((year) => ({
            value: year.toString(),
            label: year.toString()
        }));
    }
}
import {IRegionListRegion} from "../../../../search/actions/fetch_search_regions_action";
import {rankingYears} from "../../../constants/ranking";
import {IOfferRankingOptionValue} from "../../../types/IOfferRankingFormOptionValue";
import {IRankingCity} from "../../../types/IRankingCity";

interface IGetOfferRankingFormPeriodOptions {
    cities2023?: IRegionListRegion[];
    cities2022?: IRankingCity[];
    selectedCitySlug?: string;
}

export function getOfferRankingFormPeriodOptions(params: IGetOfferRankingFormPeriodOptions): IOfferRankingOptionValue[] {
    const {cities2023, cities2022, selectedCitySlug} = params;

    if (!cities2023 || !cities2022) {
        return [];
    }

    const cityIn2022 = selectedCitySlug ? Boolean(cities2022.find((city) => city.slug === selectedCitySlug)) : true;
    const cityIn2023 = selectedCitySlug ? Boolean(cities2023.find((city) => city.slug === selectedCitySlug)) : true;

    if (cityIn2022 && !cityIn2023) {
        const year2022 = rankingYears[1];

        return [
            {
                value: year2022.toString(),
                label: year2022.toString()
            }
        ];
    } else {
        return rankingYears.map((year) => ({
            value: year.toString(),
            label: year.toString()
        }));
    }
}
